export default __webpack_public_path__ + "static/img-data-prep-preview--mobile-999ee248915b6e24b5b684ebb0cb0fe7.webp";